export const getItemAssetPairs = ({ item_details, itemIds, assetIds } = {}) => {
  if (Array.isArray(item_details) && item_details.length > 0) {
    return item_details.map(item => ({
      item_id: item?.item_id || '',
      asset_id: item?.asset_id || '',
    }));
  }

  const pairCount = Math.max((itemIds || []).length, (assetIds || []).length);
  return Array.from({ length: pairCount }, (_, index) => ({
    item_id: (itemIds || [])[index] || '',
    asset_id: (assetIds || [])[index] || '',
  }));
};

export const ItemAssetPairs = ({ item_details, itemIds, assetIds, testId }) => {
  const pairs = getItemAssetPairs({ item_details, itemIds, assetIds });

  if (pairs.length === 0) return <span className="text-slate-400">-</span>;

  return (
    <div className="space-y-1.5" data-testid={testId}>
      {pairs.map((pair, index) => (
        <div key={`${pair.item_id}-${index}`} className="border-b border-slate-100 pb-1.5 last:border-0 last:pb-0">
          <div className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">Item ID</div>
          <div className="font-mono text-xs text-slate-800 break-all">{pair.item_id || '-'}</div>
          <div className="mt-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-400">Asset ID</div>
          <div className="font-mono text-xs text-slate-600 break-all">{pair.asset_id || '-'}</div>
        </div>
      ))}
    </div>
  );
};
